import React, {Component} from 'react';
import './App.css';
//import ShippingThresholdCalculator from './components/ShippingThresholdCalculator';
import CartList from './components/CartList';
//import FloatingCheckout from './components/FloatingCheckout';
import MainStore from './stores/MainStore.js';
import * as CartLibrary from './libraries/Cart.js';
import * as Upsells from './libraries/Upsells.js';
import * as Discount from './libraries/Discount.js';
import * as ShopifyData from './libraries/Shopify/Data.js';


class Cart extends Component {

  constructor(props) {
    super(props);

    this.state = {};
    //this.money = 10;
    
    
    //MainStore.cart = window.__cart;

    ///*
    window.__discount_object.initialCSVDiscounts(function(){
      if( window.__config_reactjs_cart.env !== "development" ){
        window.__discount_object.getCountry(function(country){
          //console.log("k");
          //console.log(country);
          if( country==="CA" ){
              window.__config_reactjs_cart.country = "CA";
          }

          if( window.__config_reactjs_cart.country==="CA" ) window.__config_reactjs_cart.shipping_threshold = window.__config_reactjs_cart.shipping_threshold_CA;
          window.CartReactJS.initialize();
        });
      }
      else{
        window.CartReactJS.initialize();
      }
    });
    //*/

    //window.CartReactJS.initialize();
  };

  UNSAFE_componentWillMount = () =>{
    MainStore.addChangeListener(this._onModeChange);
  };

  UNSAFE_componentWillUnmount = () =>{
    MainStore.removeChangeListener(this._onModeChange);
  };

  _onModeChange = () =>{
    //this.money+=12;
    this.setState({random:Math.random()});
  };

  initialize = () => {
    ShopifyData.getFromGraphQL(function(){
      Discount.init();
      CartLibrary.getCart();
      Upsells._adjustUpsellProducts();

    });
    
    //Discount.init();
  };

  render() {
    //console.log("parent render");
    return (
      <React.Fragment>
        <div className="container mt-2">
          <div className="row my-5">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div><h1 className="title title--primary">Your cart</h1></div>
              <div><a href="/collections/all" className="underlined-link">Continue shopping</a></div>
            </div>
          </div>

          <div className="row">
            {/*
            <div className="col-12">
              <ShippingThresholdCalculator
                max={window.__config_reactjs_cart.shipping_threshold*100}
                total={MainStore.total}
              />
            </div>
            */}
            <div className="col-12">
              <CartList/>
            </div>
          </div>
        </div>

        {/*
        <FloatingCheckout
          total={MainStore.total}
          total_original={MainStore.total_original}
          saved={MainStore.saved}
        />
        */}

      </React.Fragment>
    )
  };
}
export default Cart;